import * as actions from "store/actions/subscription";
import ISubscription from "Types/Subscription";
import IInstallment from "Types/Installment";

export interface SubscriptionState {
	items: ISubscription[];
	installments: IInstallment[];
	filter: any[];
	pages: any;
	count: number;
	loading: any;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: SubscriptionState = {
	items: [],
	installments: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false, import: false, pay: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_SUBSCRIPTIONS: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_SUBSCRIPTIONS_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_SUBSCRIPTIONS_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}
		case actions.GET_INSTALLMENTS: {
			return {
				...state,
				loading: { installments: true },
				errors: initialState.errors
			};
		}
		case actions.GET_INSTALLMENTS_SUCCESS: {
			return {
				...state,
				installments: payload || [],
				loading: { installments: false }
			};
		}
		case actions.GET_INSTALLMENTS_FAILED: {
			return {
				...state,
				loading: { installments: false },
				errors: payload
			};
		}
		case actions.PAY_INSTALLMENTS: {
			return {
				...state,
				loading: { pay: true },
				errors: initialState.errors
			};
		}
		case actions.PAY_INSTALLMENTS_SUCCESS: {
			return {
				...state,
				loading: { pay: false }
			};
		}
		case actions.PAY_INSTALLMENTS_FAILED: {
			return {
				...state,
				loading: { pay: false },
				errors: payload
			};
		}
		case actions.IMPORT_SUBSCRIPTIONS: {
			return {
				...state,
				loading: { import: true },
				errors: initialState.errors
			};
		}
		case actions.IMPORT_SUBSCRIPTIONS_SUCCESS: {
			return {
				...state,
				loading: { import: false }
			};
		}
		case actions.IMPORT_SUBSCRIPTIONS_FAILED: {
			return {
				...state,
				loading: { import: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
